import { useTranslation } from 'react-i18next';

import { getWebBoosterVairant } from '../../../constants/webBoosterType';
import { WebPageType } from '../../../constants/webPageType';
import { WebBoosterType } from '../../../models/UserStore';
import { CircleCheckbox, SvgIcon } from '../../Molecules';
import { ActionSheetContainer } from '../Containers/ActionSheetContainer';

import styles from './SwitchMemoryBoostPopup.module.css';

export type SwitchMemoryBoostPopupProps = {
  selectedBooster: WebBoosterType | undefined;
  onPrimary: () => void;
  onSelect: (selected: WebBoosterType) => void;
};

export const SwitchMemoryBoostPopup = ({
  selectedBooster,
  onPrimary,
  onSelect,
}: SwitchMemoryBoostPopupProps) => {
  const { t } = useTranslation();

  const BoosterList = [
    {
      key: WebBoosterType.Normal,
      name: getWebBoosterVairant(WebBoosterType.Normal).name,
      icon: getWebBoosterVairant(WebBoosterType.Normal).icon,
      description: getWebBoosterVairant(WebBoosterType.Normal).description,
    },
    {
      key: WebBoosterType.Bible,
      name: getWebBoosterVairant(WebBoosterType.Bible).name,
      icon: getWebBoosterVairant(WebBoosterType.Bible).icon,
      description: getWebBoosterVairant(WebBoosterType.Bible).description,
    },
  ];

  return (
    <ActionSheetContainer onPrimaryButtonClick={onPrimary}>
      <div className={styles.switchMemory}>
        <div className={styles.titleRow}>
          <p className={styles.title}>{t('JOYAJOY Memory Boosters')}</p>
        </div>
        <hr className={styles.dividerPage} style={{ marginTop: '10px' }} />

        <div>
          {BoosterList.map((item, index) => (
            <div key={item.name}>
              <div
                className={styles.memoryItem}
                onClick={() => {
                  onSelect(item.key);
                }}
              >
                <SvgIcon name={item.icon} className={styles.boosterIcon} />
                <div className={styles.textBar}>
                  <p className={`${styles.itemTitle}`}>{t(item.name)}</p>
                  <p className={styles.itemDescription}>
                    {t(item.description)}
                  </p>
                </div>
                <CircleCheckbox
                  checked={selectedBooster === item.key}
                  webPageType={WebPageType.JOYAJOY}
                />
              </div>
              {index < BoosterList.length - 1 && (
                <hr className={styles.dividerPage} />
              )}
            </div>
          ))}
        </div>
      </div>
    </ActionSheetContainer>
  );
};
